const ExclusiveCountryCode = {
  AE: 'AE',
  AU: 'AU',
  DZ: 'DZ',
  // BA: 'BA', Vueko temporarily removed
  CN: 'CN',
  CY: 'CY',
  CZ: 'CZ',
  DK: 'DK',
  EG: 'EG',
  GR: 'GR',
  HU: 'HU',
  IL: 'IL',
  IN: 'IN',
  // IS: 'IS', not signed yet
  // MK: 'MK', Vueko temporarily removed
  // NO: 'NO', temporarily removed
  NZ: 'NZ',
  PL: 'PL',
  PS: 'PS',
  RO: 'RO',
  // RS: 'RS', Vueko temporarily removed
  // TR: 'TR', temporarily removed
  UA: 'UA',
  // UK: 'UK', not signed yet
  US: 'US',
}

const TranslatedCountryCode = {
  DE: 'DE',
  ES: 'ES',
  IT: 'IT',
  FR: 'FR',
  NL: 'NL',
}

const HidePricesCountryCode = {
  ES: 'ES',
  IT: 'IT',
  PT: 'PT',
}

const exclusive = {
  [ExclusiveCountryCode.DZ]: {
    name: 'Algeria',
    flag: '🇩🇿',
    language: 'English',
    link: '/exclusive-distributor-algeria',
    title: 'Visit our official Algeria 🇩🇿 website',
    alt: 'Exclusive 1Home distributor in Algeria',
    btn_redirect: 'Visit 1Home for Algeria',
    btn_close: 'Continue to the global site',
  },
  [ExclusiveCountryCode.AU]: {
    name: 'Australia',
    flag: '🇦🇺',
    language: 'English',
    link: '/exclusive-distributor-australia',
    title: 'Visit our official Australia 🇦🇺 website',
    alt: 'Exclusive 1Home distributor in Australia',
    btn_redirect: 'Visit 1Home for Australia',
    btn_close: 'Continue to the global site',
  },
  // [ExclusiveCountryCode.BA]: {
  //   name: 'Bosnia and Herzegovina',
  //   flag: '🇧🇦',
  //   language: 'Bosanski',
  //   link: '/exclusive-distributor-bosnia-and-herzegovina',
  //   title: 'Posjetite našu zvaničnu web stranicu za Bosnu i Hercegovinu 🇧🇦',
  //   alt: 'Ekskluzivni 1Home distributer u Bosni i Hercegovini',
  //   btn_redirect: 'Posjetite 1Home za Bosnu i Hercegovinu',
  //   btn_close: 'Nastavite na globalni sajt',
  // },
  [ExclusiveCountryCode.CN]: {
    name: 'China',
    flag: '🇨🇳',
    language: '中文',
    link: '/exclusive-distributor-china',
    title: '访问我们的中国 🇨🇳 官方网站',
    alt: '1Home 中国独家经销商',
    btn_redirect: '访问 1Home 中国',
    btn_close: '继续访问全球网站',
  },
  [ExclusiveCountryCode.CY]: {
    name: 'Cyprus',
    flag: '🇨🇾',
    language: 'Ελληνικά',
    link: '/exclusive-distributor-cyprus',
    title: 'Επισκεφθείτε την επίσημη ιστοσελίδα μας για την Κύπρο 🇨🇾',
    alt: 'Αποκλειστικός διανομέας 1Home στην Κύπρο',
    btn_redirect: 'Επισκεφθείτε το 1Home για την Κύπρο',
    btn_close: 'Συνεχίστε στην παγκόσμια ιστοσελίδα',
  },
  [ExclusiveCountryCode.CZ]: {
    name: 'Czechia',
    flag: '🇨🇿',
    language: 'Čeština',
    link: '/exclusive-distributor-czechia',
    title: 'Navštivte naše oficiální webové stránky pro Česko 🇨🇿',
    alt: 'Exkluzivní distributor 1Home v Česku',
    btn_redirect: 'Navštivte 1Home pro Česko',
    btn_close: 'Pokračujte na globální web',
  },
  [ExclusiveCountryCode.DK]: {
    name: 'Denmark',
    flag: '🇩🇰',
    language: 'Dansk',
    link: '/exclusive-distributor-denmark',
    title: 'Besøg vores officielle Danmark 🇩🇰 hjemmeside',
    alt: 'Eksklusiv 1Home distributør i Danmark',
    btn_redirect: 'Besøg 1Home for Danmark',
    btn_close: 'Fortsæt til den globale side',
  },
  [ExclusiveCountryCode.EG]: {
    name: 'Egypt',
    flag: '🇪🇬',
    language: 'English',
    link: '/exclusive-distributor-egypt',
    title: 'Visit our official Egypt 🇪🇬 website',
    alt: 'Exclusive 1Home distributor in Egypt',
    btn_redirect: 'Visit 1Home for Egypt',
    btn_close: 'Continue to the global site',
  },
  [ExclusiveCountryCode.GR]: {
    name: 'Greece',
    flag: '🇬🇷',
    language: 'Ελληνικά',
    link: '/exclusive-distributor-greece',
    title: 'Επισκεφθείτε την επίσημη ιστοσελίδα μας για την Ελλάδα 🇬🇷',
    alt: 'Αποκλειστικός διανομέας 1Home στην Ελλάδα',
    btn_redirect: 'Επισκεφθείτε το 1Home για την Ελλάδα',
    btn_close: 'Συνεχίστε στην παγκόσμια ιστοσελίδα',
  },
  [ExclusiveCountryCode.HU]: {
    name: 'Hungary',
    flag: '🇭🇺',
    language: 'Magyar',
    link: '/exclusive-distributor-hungary',
    title: 'Látogasd meg hivatalos magyar 🇭🇺 weboldalunkat',
    alt: 'Exkluzív 1Home forgalmazó Magyarországon',
    btn_redirect: 'Látogasd meg a 1Home Magyarországot',
    btn_close: 'Folytatás a globális oldalra',
  },
  [ExclusiveCountryCode.IL]: {
    name: 'Israel',
    flag: '🇮🇱',
    language: 'English',
    link: '/exclusive-distributor-israel',
    title: 'Visit our official Israel 🇮🇱 website',
    alt: 'Exclusive 1Home distributor in Israel',
    btn_redirect: 'Visit 1Home for Israel',
    btn_close: 'Continue to the global site',
  },
  [ExclusiveCountryCode.IN]: {
    name: 'India',
    flag: '🇮🇳',
    language: 'English',
    link: '/exclusive-distributor-india',
    title: 'Visit our official India 🇮🇳 website',
    alt: 'Exclusive 1Home distributor in India',
    btn_redirect: 'Visit 1Home for India',
    btn_close: 'Continue to the global site',
  },
  // [ExclusiveCountryCode.IS]: {
  //   name: 'Iceland',
  //   flag: '🇮🇸',
  //   language: 'English',
  //   link: '/exclusive-distributor-iceland',
  //   title: 'Visit our official Iceland 🇮🇸 website',
  //   alt: 'Exclusive 1Home distributor in Iceland',
  //   btn_redirect: 'Visit 1Home for Iceland',
  //   btn_close: 'Continue to the global site',
  // },
  [ExclusiveCountryCode.NZ]: {
    name: 'New Zealand',
    flag: '🇳🇿',
    language: 'English',
    link: '/exclusive-distributor-new-zealand',
    title: 'Visit our official New Zealand 🇳🇿 website',
    alt: 'Exclusive 1Home distributor in New Zealand',
    btn_redirect: 'Visit 1Home for New Zealand',
    btn_close: 'Continue to the global site',
  },
  // [ExclusiveCountryCode.MK]: {
  //   name: 'North Macedonia',
  //   flag: '🇲🇰',
  //   language: 'Македонски',
  //   link: '/exclusive-distributor-north-macedonia',
  //   title: 'Посетете ја нашата официјална веб-страница за Северна Македонија 🇲🇰',
  //   alt: 'Ексклузивен 1Home дистрибутер во Северна Македонија',
  //   btn_redirect: 'Посетете 1Home за Северна Македонија',
  //   btn_close: 'Продолжете на глобалниот веб-сајт',
  // },
  // [ExclusiveCountryCode.NO]: {
  //   name: 'Norway',
  //   flag: '🇳🇴',
  //   language: 'Norsk',
  //   link: '/exclusive-distributor-norway',
  //   title: 'Besøk vår offisielle Norge 🇳🇴 nettside',
  //   alt: 'Eksklusiv 1Home-distributør i Norge',
  //   btn_redirect: 'Besøk 1Home for Norge',
  //   btn_close: 'Fortsett til den globale siden',
  // },
  [ExclusiveCountryCode.PS]: {
    name: 'Palestine',
    flag: '🇵🇸',
    language: 'العربية',
    link: '/exclusive-distributor-palestine',
    title: 'قم بزيارة موقعنا الرسمي لفلسطين 🇵🇸',
    alt: 'الموزع الحصري لمنتجات 1Home في فلسطين',
    btn_redirect: 'قم بزيارة 1Home لفلسطين',
    btn_close: 'المتابعة إلى الموقع العالمي',
  },
  [ExclusiveCountryCode.PL]: {
    name: 'Poland',
    flag: '🇵🇱',
    language: 'Polski',
    link: '/exclusive-distributor-poland',
    title: 'Odwiedź naszą oficjalną stronę internetową dla Polski 🇵🇱',
    alt: 'Wyłączny dystrybutor 1Home w Polsce',
    btn_redirect: 'Odwiedź 1Home dla Polski',
    btn_close: 'Kontynuuj na globalnej stronie',
  },
  [ExclusiveCountryCode.RO]: {
    name: 'Romania',
    flag: '🇷🇴',
    language: 'English',
    link: '/exclusive-distributor-romania',
    title: 'Visit our official Romania 🇷🇴 website',
    alt: 'Exclusive 1Home distributor in Romania',
    btn_redirect: 'Visit 1Home for Romania',
    btn_close: 'Continue to the global site',
  },
  // [ExclusiveCountryCode.RS]: {
  //   name: 'Serbia',
  //   flag: '🇷🇸',
  //   language: 'Srpski',
  //   link: '/exclusive-distributor-serbia',
  //   title: 'Posetite našu zvaničnu web stranicu za Srbiju 🇷🇸',
  //   alt: 'Ekskluzivni 1Home distributer u Srbiji',
  //   btn_redirect: 'Posetite 1Home za Srbiju',
  //   btn_close: 'Nastavite na globalni sajt',
  // },
  // [ExclusiveCountryCode.TR]: {
  //   name: 'Turkey',
  //   flag: '🇹🇷',
  //   language: 'Türkçe',
  //   link: '/exclusive-distributor-turkey',
  //   title: 'Resmi Türkiye 🇹🇷 web sitemizi ziyaret edin',
  //   alt: '1Home Türkiye için özel distribütör',
  //   btn_redirect: '1Home Türkiye’yi ziyaret edin',
  //   btn_close: 'Global siteye devam et',
  // },
  [ExclusiveCountryCode.UA]: {
    name: 'Ukraine',
    flag: '🇺🇦',
    language: 'Українська',
    link: '/exclusive-distributor-ukraine',
    title: 'Відвідайте наш офіційний вебсайт для України 🇺🇦',
    alt: 'Ексклюзивний дистриб’ютор 1Home в Україні',
    btn_redirect: 'Відвідати 1Home для України',
    btn_close: 'Продовжити на глобальний сайт',
  },
  // [ExclusiveCountryCode.UK]: {
  //   name: 'United Kingdom',
  //   flag: '🇬🇧',
  //   language: 'English',
  //   link: '/exclusive-distributor-uk',
  //   title: 'Visit our official UK 🇬🇧 website',
  //   alt: 'Exclusive 1Home distributor in the United Kingdom',
  // },
  [ExclusiveCountryCode.AE]: {
    name: 'United Arab Emirates',
    flag: '🇦🇪',
    language: 'English',
    link: '/exclusive-distributor-uae',
    title: 'Visit our official UAE 🇦🇪 website',
    alt: 'Exclusive 1Home distributor in the United Arab Emirates',
    btn_redirect: 'Visit 1Home for UAE',
    btn_close: 'Continue to the global site',
  },
  [ExclusiveCountryCode.US]: {
    name: 'United States',
    flag: '🇺🇸',
    language: 'English',
    link: '/exclusive-distributor-usa',
    title: 'Visit our official USA 🇺🇸 website',
    alt: 'Exclusive 1Home distributor in the United States',
    btn_redirect: 'Visit 1Home for USA',
    btn_close: 'Continue to the global site',
  },
}

const translated = {
  [TranslatedCountryCode.DE]: {
    name: 'Deutschland',
    flag: '🇩🇪',
    link: '/de',
    title: 'Besuchen Sie unsere offizielle Website für Deutschland 🇩🇪',
    alt: '1Home für Deutschland',
    btn_redirect: 'Zur deutschen 1Home Website',
    btn_close: 'Weiter zur globalen Website & Weiterleitung beim Checkout',
  },
  [TranslatedCountryCode.ES]: {
    name: 'España',
    flag: '🇪🇸',
    link: '/es',
    title: 'Visita nuestra web oficial para España 🇪🇸',
    alt: '1Home para España',
    btn_redirect: 'Visita 1Home para España',
    btn_close: 'Continúe al sitio global y sea redirigido al pagar',
  },
  [TranslatedCountryCode.IT]: {
    name: 'Italia',
    flag: '🇮🇹',
    link: '/it',
    title: 'Visita il nostro sito ufficiale per Italia 🇮🇹',
    alt: '1Home in Italia',
    btn_redirect: 'Visita 1Home Italia',
    btn_close: 'Continua al sito globale e verrai reindirizzato al checkout',
  },
  [TranslatedCountryCode.FR]: {
    name: 'France',
    flag: '🇫🇷',
    link: '/fr',
    title: 'Visitez notre site officiel pour France 🇫🇷',
    alt: '1Home en France',
    btn_redirect: 'Visitez 1Home France',
    btn_close: 'Continuer sur le site global et accéder au paiement',
  },
  [TranslatedCountryCode.NL]: {
    name: 'Nederland',
    flag: '🇳🇱',
    link: '/nl',
    title: 'Bezoek onze officiële website voor Nederland 🇳🇱',
    alt: '1Home in Nederland',
    btn_redirect: 'Bezoek 1Home Nederland',
    btn_close: 'Ga verder naar de globale website en word naar de checkout doorgestuurd',
  },
}

const contactBasePath = '/get-1home-in-your-country'

const exclusiveContact = [
  {
    id: [ExclusiveCountryCode.DZ],
    name: 'Algeria',
    slug: 'algeria',
    company_name: 'DOMO DZ',
    address: 'Petit Staoueli, Property Lot No. 703, Dély Ibrahim 16302, Algiers, Algeria',
    phone: '+213 550 50 88 97',
    email: 'contact@domodz.com',
    website: 'https://www.domodz.com',
    link: 'mailto:contact@domodz.com',
  },
  {
    id: ['AR'],
    name: 'Argentina',
    slug: 'argentina',
    company_name: 'THI s.a.i.c.',
    address: 'Av. Uruguay 2522, Béccar, Buenos Aires',
    phone: '+54 911 24686983',
    email: 'info@mdt.ar',
    website: 'https://www.tiendaknx.ar',
    link: 'mailto:info@mdt.ar',
  },
  {
    id: [ExclusiveCountryCode.AU],
    name: 'Australia',
    slug: 'australia',
    company_name: 'Kadan',
    address: 'Unit 8, 9-11 Chaplin Drive, Lane Cove West, NSW 2066',
    phone: '+61 1300 784 936',
    email: 'info@kadan.com.au',
    website: 'https://kadan.com.au',
    link: 'mailto:info@kadan.com.au',
  },
  {
    id: ['BE'],
    name: 'Belgium / 1wAVe',
    slug: 'belgium-1wave',
    company_name: '1wAVe SRL',
    address: "Rue de l'Église 19, 4570 Marchin, Belgium",
    email: 'info@1wave.be',
    website: 'https://www.1wave.be',
    link: 'mailto:info@1wave.be',
  },
  {
    id: ['BE'],
    name: 'Belgium / InstaVer',
    slug: 'belgium-instaver',
    company_name: 'InstaVer Systems B.V.',
    address: 'Duitslandlaan 33, 2391 PC Hazerswoude-Dorp, The Netherlands',
    phone: '+31 (0) 85 - 023 90 75',
    email: 'warehouse@instaver.nl',
    website: 'https://www.knxwarehouse.com',
    link: 'mailto:warehouse@instaver.nl',
  },
  // {
  //   id: [ExclusiveCountryCode.BA],
  //   name: 'BiH',
  //   slug: 'bosnia-and-herzegovina',
  //   company_name: 'Vueko d.o.o.',
  //   address: 'Đorđa Magaraševića 9/3, Novi Sad 21000, Srbija',
  //   phone: '+381 60 633 6007',
  //   email: 'office@vueko.net',
  //   website: 'https://vueko.net',
  //   link: 'mailto:office@vueko.net',
  // },
  // Unhide when paid
  // {
  //   id: [ExclusiveCountryCode.CN],
  //   name: 'China',
  //   slug: 'china',
  //   company_name: '',
  //   address: '',
  //   phone: '',
  //   email: '',
  //   website: '',
  //   link: 'mailto:',
  // },
  {
    id: [ExclusiveCountryCode.CY],
    name: 'Cyprus',
    slug: 'cyprus',
    company_name: 'GABS Systems Ltd.',
    email: 'sales@gabs.systems',
    website: 'https://www.gabs.systems',
    link: 'mailto:sales@gabs.systems',
  },
  {
    id: [ExclusiveCountryCode.CZ],
    name: 'Czechia',
    slug: 'czechia',
    company_name: 'YATUN, s.r.o.',
    address: 'V Olsinach 2300, Praha 100 00',
    phone: '+420 737 513 890',
    email: 'martin.wokoun@yatun.cz',
    website: 'https://www.yatun.cz',
    link: 'mailto:martin.wokoun@yatun.cz',
  },
  {
    id: [ExclusiveCountryCode.DK],
    name: 'Denmark',
    slug: 'denmark',
    company_name: 'KNX El & Teknik ApS',
    address: 'Gammel Bagsværdvej 64, 2800 Kongens Lyngby',
    phone: '+45 60 89 70 11',
    email: 'sl@knx.dk',
    website: 'https://www.knx.dk',
    link: 'mailto:sl@knx.dk',
  },
  {
    id: [ExclusiveCountryCode.EG],
    name: 'Egypt',
    slug: 'egypt',
    company_name: 'Domotec Automation',
    address: 'Villa 225, West Golf Katameya, 11936 Cairo',
    phone: '+20 109 001 1336',
    email: 'sales@domotecautomation.com',
    website: 'https://domotec-automation.odoo.com',
    link: 'mailto:sales@domotecautomation.com',
  },
  {
    id: [TranslatedCountryCode.FR],
    name: 'France',
    slug: 'france',
    company_name: 'Blackstone Store',
    address: '7 rue Jean Calvin, 80000 Amiens, France',
    phone: '+33 1 85 09 08 27',
    email: 'contact@blackstone-store.com',
    website: 'https://blackstone-store.com',
    link: 'mailto:contact@blackstone-store.com',
  },
  {
    id: [ExclusiveCountryCode.GR],
    name: 'Greece',
    slug: 'greece',
    company_name: 'Kafkas',
    address: '',
    phone: '+30 216 300 3333',
    email: 'customercare@kafkas.gr',
    website: 'https://www.kafkas.gr',
    link: 'mailto:customercare@kafkas.gr',
  },
  {
    id: [ExclusiveCountryCode.HU],
    name: 'Hungary',
    slug: 'hungary',
    company_name: 'TermiCont Elektro Kft',
    address: '2142 Nagytarcsa Csonka János utca 4. J/6',
    phone: '+36 20 983 6240',
    email: 'info@termicont.hu',
    website: 'https://www.termicont.hu',
    link: 'mailto:info@termicont.hu',
  },
  {
    id: ['IS'],
    name: 'Iceland',
    slug: 'iceland',
    company_name: 'Reykjafell ehf.',
    address: 'Blikastaðavegi 2, 112 Reykjavík, Iceland',
    phone: '+354 575 6612',
    email: 'adam@reykjafell.is',
    website: 'https://www.reykjafell.is',
    link: 'mailto:adam@reykjafell.is',
  },
  {
    id: [ExclusiveCountryCode.IN],
    name: 'India',
    slug: 'india',
    company_name: 'Morion Automation Pvt. Ltd.',
    address: 'Morion Automation Pvt. Ltd., 4th Floor, Fortune Monarch, Road No 36, Jubliee Hills, Madhapur, Hyderabad',
    phone: '+91 90006 00125',
    email: 'info@morion.in',
    website: 'https://www.morion.in',
    link: 'mailto:info@morion.in',
  },
  {
    id: [ExclusiveCountryCode.IL],
    name: 'Israel',
    slug: 'israel',
    company_name: 'Inspera Smart Home',
    address: '',
    phone: '+972 72 395 3007',
    email: 'office@inspera.co.il',
    website: 'https://www.inspera.co.il',
    link: 'mailto:office@inspera.co.il',
  },
  {
    id: [TranslatedCountryCode.IT],
    name: 'Italy',
    slug: 'italy',
    company_name: '',
    address: '',
    phone: '+39 351 364 9546',
    email: 'dragos@1home.it',
    website: 'https://www.1home.io/it',
    link: 'mailto:dragos@1home.it',
  },
  {
    id: ['KW'],
    name: 'Kuwait',
    slug: 'kuwait',
    company_name: 'BASS Company For Security Systems, Installation and Maintenance W.L.L',
    address: '5th Floor, wafra building, Ahmed Al Jaber ST., Sharq, Kuwait',
    phone: '+965 2244 1592',
    email: 'info@basskuwait.com / rganga@basskuwait.com',
    website: 'https://www.basskuwait.com',
    link: 'mailto:info@basskuwait.com',
  },
  {
    id: ['LU'],
    name: 'Luxembourg',
    slug: 'luxembourg',
    company_name: 'InstaVer Systems B.V.',
    address: 'Duitslandlaan 33, 2391 PC Hazerswoude-Dorp, The Netherlands',
    phone: '+31 (0) 85 - 023 90 75',
    email: 'warehouse@instaver.nl',
    website: 'https://www.knxwarehouse.com',
    link: 'mailto:warehouse@instaver.nl',
  },
  {
    id: [TranslatedCountryCode.NL],
    name: 'Netherlands',
    slug: 'netherlands',
    company_name: 'InstaVer Systems B.V.',
    address: 'Duitslandlaan 33, 2391 PC Hazerswoude-Dorp, The Netherlands',
    phone: '+31 (0) 85 - 023 90 75',
    email: 'warehouse@instaver.nl',
    website: 'https://www.knxwarehouse.com',
    link: 'mailto:warehouse@instaver.nl',
  },
  {
    id: [ExclusiveCountryCode.NZ],
    name: 'New Zealand',
    slug: 'new-zealand',
    company_name: 'Knxtra Ltd',
    address: '287 Hoon Hay Road, Christchurch 8025',
    phone: '+64 27 727 4479',
    email: 'jacob@knxtra.co.nz',
    website: 'https://www.knxtra.co.nz',
    link: 'mailto:jacob@knxtra.co.nz',
  },
  // {
  //   id: [ExclusiveCountryCode.MK],
  //   name: 'North Macedonia',
  //   slug: 'north-macedonia',
  //   company_name: 'Vueko d.o.o.',
  //   address: 'Đorđa Magaraševića 9/3, Novi Sad 21000, Srbija',
  //   phone: '+381 60 633 6007',
  //   email: 'office@vueko.net',
  //   website: 'https://vueko.net',
  //   link: 'mailto:office@vueko.net',
  // },
  // {
  //   id: [ExclusiveCountryCode.NO],
  //   name: 'Norway',
  //   slug: 'norway',
  //   company_name: 'Smarthuset AS',
  //   address: 'Presidentgata 3C, 0474 Oslo',
  //   phone: '+47 97 97 97 29',
  //   email: 'post@smarthuset.no',
  //   website: 'https://www.smarthuset.no',
  //   link: 'mailto:post@smarthuset.no',
  // },
  {
    id: [ExclusiveCountryCode.PS],
    name: 'Palestine',
    slug: 'palestine',
    company_name: 'Alfanar',
    address: '',
    phone: '+972 568 522 031',
    email: 'yasmeen@alfanar.ps',
    website: 'https://www.alfanar.ps',
    link: 'mailto:yasmeen@alfanar.ps',
  },
  {
    id: [ExclusiveCountryCode.PL],
    name: 'Poland',
    slug: 'poland',
    company_name: 'DYSTRON',
    address: 'Hetmańska 26, 60-252 Poznań, Poljska',
    phone: '+48 515 545 946',
    email: 'zamowienia@dystron.pl',
    website: 'https://www.dystron.pl',
    link: 'mailto:zamowienia@dystron.p',
  },
  {
    id: [HidePricesCountryCode.PT],
    name: 'Portugal',
    slug: 'portugal',
    company_name: 'Genesis Home Technology Architects',
    address: 'Genesis HTA, Ronda Can Rabada 23, Nave 1, 08860 Castelldefels',
    phone: '+39 335 875 7705',
    email: 'giorgio@genesis-hta.eu',
    website: 'https://genesis-hta.eu',
    link: 'mailto:giorgio@genesis-hta.eu',
  },
  {
    id: [ExclusiveCountryCode.RO],
    name: 'Romania',
    slug: 'romania',
    company_name: 'Widomars solution srl',
    address: 'București Nord 10, Global City Business Park, C2 Et3, Bucuresti 077190',
    phone: '+40 750 439 003',
    email: 'dragos@1home.it',
    website: 'www.widomars.com',
    link: 'mailto:dragos@1home.it',
  },
  // {
  //   id: [ExclusiveCountryCode.RS],
  //   name: 'Serbia',
  //   slug: 'serbia',
  //   company_name: 'Vueko d.o.o.',
  //   address: 'Đorđa Magaraševića 9/3, Novi Sad 21000, Srbija',
  //   phone: '+381 60 633 6007',
  //   email: 'office@vueko.net',
  //   website: 'https://vueko.net',
  //   link: 'mailto:office@vueko.net',
  // },
  {
    id: [TranslatedCountryCode.ES],
    name: 'Spain / Genesis HTA',
    slug: 'spain-genesis-hta',
    company_name: 'Genesis Home Technology Architects',
    address: 'Genesis HTA, Ronda Can Rabada 23, Nave 1, 08860 Castelldefels',
    phone: '+39 335 875 7705',
    email: 'giorgio@genesis-hta.eu',
    website: 'https://genesis-hta.eu',
    link: 'mailto:giorgio@genesis-hta.eu',
  },
  {
    id: [TranslatedCountryCode.ES],
    name: 'Spain / Ingenia-LED',
    slug: 'spain-ingenia-led',
    company_name: 'Ingenia-LED',
    address: 'Calle ingeniero De la Torre Acosta N 1, Cp 29007, Malaga, Spain',
    phone: '+34 951 392 899',
    email: 'info@ingenia-led.com',
    website: 'http://www.ingenia-led.com',
    link: 'mailto:info@ingenia-led.com',
  },
  {
    id: ['CH'],
    name: 'Switzerland / Bitelec',
    slug: 'switzerland-bitelec',
    company_name: 'Bitelec GmbH',
    address: 'Pilatusstrasse 22, 6072 Sachseln, Switzerland',
    phone: '+41 41 748 17 66',
    email: 'info@bitelec.ch / mario.burri@bitelec.ch',
    website: 'https://www.bitelec.ch',
    link: 'mailto:info@bitelec.ch',
  },
  {
    id: ['CH'],
    name: 'Switzerland / Domo-Supply',
    slug: 'switzerland-domo-supply',
    company_name: 'Domo-Supply',
    address: 'Place de la Gare 14, CH-1580 Avenches, Switzerland',
    phone: '+41 32 560 35 15',
    email: 'sales@domo-supply.com',
    website: 'https://www.domo-supply.com',
    link: 'mailto:sales@domo-supply.com',
  },
  // {
  //   id: [ExclusiveCountryCode.TR],
  //   name: 'Turkey',
  //   slug: 'turkey',
  //   company_name: 'Esbau',
  //   address: 'Sherifali neighborhood Hatat sokak no:8, 34740 Esenyurt/Istanbul',
  //   phone: '+90 541 296 0085',
  //   email: 's.kocarslan@esbau.com.tr',
  //   website: 'https://www.esbau.com',
  //   link: 'mailto:s.kocarslan@esbau.com.tr',
  // },
  {
    id: [ExclusiveCountryCode.UA],
    name: 'Ukraine',
    slug: 'ukraine',
    company_name: 'Smart Tech',
    address: '28A Panasa Myrnoho Str. Kyiv, Ukraine',
    phone: '+380 44 545 7706',
    email: 'sales@smarttech.com.ua',
    website: 'https://www.smarttech.com.ua',
    link: 'mailto:sales@smarttech.com.ua',
  },
  {
    id: [ExclusiveCountryCode.AE],
    name: 'United Arab Emirates',
    slug: 'united-arab-emirates',
    company_name: 'Cache Robotics Trading LLC',
    address: 'Port Saeed ARAB BANK BUILDING, Office SM1-02-701, Dubai, UAE',
    phone: '+971 58 541 2806',
    email: 'sales@cache.ae',
    website: 'https://cache.ae',
    link: 'mailto:sales@cache.ae',
  },
  {
    id: [ExclusiveCountryCode.UK],
    name: 'UK / MyKNXStore',
    slug: 'united-kingdom-myknxstore',
    company_name: 'MyKNXStore',
    address: '2A Poplar Court, Atley Way, Cramlington, NE23 1WA',
    phone: '+44 191 497 0777',
    email: 'team@myknxstore.co.uk',
    website: 'https://www.myknxstore.co.uk',
    link: 'mailto:team@myknxstore.co.uk',
  },
  {
    id: [ExclusiveCountryCode.UK],
    name: 'UK / Ivory Egg',
    slug: 'united-kingdom-ivory-egg',
    company_name: 'Ivory Egg (UK) Ltd',
    address: '38 Churchill Park, Colwick, Nottingham, NG4 2HF',
    phone: '+44 3333 079 100',
    email: 'info@ivoryegg.co.uk',
    website: 'https://www.ivoryegg.co.uk',
    link: 'mailto:info@ivoryegg.co.uk',
  },
  {
    id: [ExclusiveCountryCode.US],
    name: 'United States',
    slug: 'united-states',
    company_name: 'KNX Supply',
    address: 'Wolf Building Technologies LLC, 7950 NW 53rd Street, Suite 337, Miami, Florida 33166',
    phone: '+1 786 956 6821',
    email: 'support@knxsupply.com',
    website: 'https://www.knxsupply.com',
    link: 'mailto:support@knxsupply.com',
  },
]

module.exports = {
  contactBasePath,
  ExclusiveCountryCode,
  TranslatedCountryCode,
  HidePricesCountryCode,
  exclusive,
  translated,
  exclusiveContact,
}
